import { render, staticRenderFns } from "./PaymentsMultiPage.vue?vue&type=template&id=69f8b5e9&"
import script from "./PaymentsMultiPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsMultiPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports